<template>
  <div>
    <div class="natGateway-title">
      <div>{{ $t("RAM.ALI.NatGateway.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:natGateway:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:ali:natGateway:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="redis-top">
      <nat-gateway-search ref="child"></nat-gateway-search>
    </div>
    <table-nat-gateway></table-nat-gateway>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import NatGatewaySearch from "./NatGatewaySearch";
import TableNatGateway from "./TableNatGateway";
import Export from "../Export";

export default {
  name: "NatGateway",
  components: {
    NatGatewaySearch,
    TableNatGateway,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountIdList: [],
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 20,
          accountType: 1
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        accountName: this.$refs.child.accountName,
        companyId: this.$refs.child.companyId,
        accountIdList: this.$refs.child.accountIdList,
        natGatewayId: this.$refs.child.natGatewayId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAliNatGateway(exportDTO).then(res => {
        let fileName = "NatGateway.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success("导出成功");
      });
    }
  }
};
</script>

<style scoped>
.natGateway-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.natGateway-title > div:nth-child(1) {
  float: left;
}
.natGateway-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.natGateway-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/natGateway/NatGateway.vue